// Generated from contracts/runtime/jsonResponse.ts; do not edit.
/** Canonical JSON transport policy. Generated into independent Web/Mobile bundles. */
type JsonResponseMetadata = Pick<Response, 'ok' | 'status' | 'headers'>;

export class InvalidJsonResponseError extends Error {
  readonly code = 'INVALID_JSON_RESPONSE';
  readonly status: number;
  readonly outcomeUnknown: boolean;

  constructor(status: number, method: string) {
    const outcomeUnknown = !['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase());
    super(outcomeUnknown
      ? 'システムが処理結果を確認できませんでした。最新の状態を確認してから再度操作してください。'
      : 'システムが情報を取得できませんでした。再度お試しください。');
    this.name = 'InvalidJsonResponseError';
    this.status = status;
    this.outcomeUnknown = outcomeUnknown;
  }
}

/** HTTP failures keep their status/auth semantics even if a gateway returns HTML. */
export function decodeJsonResponse(
  response: JsonResponseMetadata,
  text: string,
  method = 'GET',
): unknown {
  if (!response.ok) {
    try { return text.trim() ? JSON.parse(text) as unknown : null; }
    catch { return null; }
  }
  if (method.toUpperCase() === 'HEAD' || [204, 205].includes(response.status)) return null;
  const mediaType = (response.headers?.get?.('content-type') || '').split(';')[0].trim().toLowerCase();
  if (!/^application\/(?:json|[a-z0-9!#$&^_.+-]+\+json)$/.test(mediaType) || !text.trim()) {
    throw new InvalidJsonResponseError(response.status, method);
  }
  try { return JSON.parse(text) as unknown; }
  catch { throw new InvalidJsonResponseError(response.status, method); }
}
